<template>
  <section id="content-seller-info">
    <h2>Seller Information</h2>

    <div class="info-grid list">
      <div class="info-item-group">
        <div class="d-flex align-center">
          <img src="./assets/badge.svg" class="mr-5" />
          <span class="d-inline font-weight-bold sansation_title mr-6">{{ owners }}</span>
          <span class="d-inline sansation label_size">{{ ownerLabel }}</span>
        </div>
      </div>

      <div class="info-item-group">
        <div class="d-flex align-center">
          <img src="./assets/employees-laurel.svg" class="mr-5" />
          <span class="d-inline font-weight-bold sansation_title mr-6">{{ employeesLicensed }}</span>
          <span class="d-inline sansation font-weight-bold label_size">{{ licensedEmployeeLabel }}</span>
        </div>
      </div>

      <div class="info-item-group">
        <img src="./assets/laurel.svg" />
        <label class="font-weight-bold">Owner License(s):</label>
        <span>{{ ownerLicenses }}</span>
      </div>

      <div class="info-item-group">
        <img src="./assets/laurel.svg" />
        <label>Employee License(s):</label>
        <span>{{ employeeLicenses }}</span>
      </div>

      <div class="info-item-group">
        <img src="./assets/ribbon.svg" />
        <label class="font-weight-bold">Owner Designation(s):</label>
        <span>{{ ownerDesignations }}</span>
      </div>

      <div class="info-item-group">
        <img src="./assets/ribbon.svg" />
        <label>Employee Designation(s):</label>
        <span>{{ employeeDesignations }}</span>
      </div>

      <div class="info-item-group">
        <!-- <img src="./assets/compass.svg" />
        <label>Years In Business</label>
        <span>{{ yearsInBusiness }} {{ yearLabel }}</span> -->
        <div class="d-flex align-center">
          <img src="./assets/compass.svg" class="mr-5" />
          <span class="d-inline font-weight-bold sansation_title mr-6">{{ yearsInBusiness }}</span>
          <span class="d-inline sansation label_size">Years In Business</span>
        </div>
      </div>

      <div class="info-item-group">
        <!-- <img src="./assets/employees.svg" />
        <label>Unlicensed Employees</label>
        <span>{{ employeesUnlicensed }}</span> -->
        <div class="d-flex align-center">
          <img src="./assets/employees.svg" class="mr-5" />
          <span class="d-inline font-weight-bold sansation_title mr-6">{{ employeesUnlicensed }}</span>
          <span class="d-inline sansation font-weight-bold label_size">{{ unlicensedEmployeeLabel }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'DetailsSellerInformation',
  props: {
    owners: {
      type: String,
      default: '1',
    },
    ownerLicenses: {
      type: String,
      default: 'N/A',
    },
    ownerDesignations: {
      type: String,
      default: 'N/A',
    },
    yearsInBusiness: {
      type: String,
      default: '1',
    },
    employeesLicensed: {
      type: String,
      default: '0',
    },
    employeesUnlicensed: {
      type: String,
      default: '0',
    },
    employeeLicenses: {
      type: String,
      default: 'N/A',
    },
    employeeDesignations: {
      type: String,
      default: 'N/A',
    },
  },

  computed: {
    ownerLabel () {
      const num = Number(this.owners)
      return `Owner${num === 1 ? '' : 's'}`
    },

    licensedEmployeeLabel () {
      const num = Number(this.employeesLicensed)
      return `Licensed Employee${num === 1 ? '' : 's'}`
    },

    unlicensedEmployeeLabel () {
      const num = Number(this.employeesUnlicensed)
      return `Unlicensed Employee${num === 1 ? '' : 's'}`
    },

    yearLabel () {
      const num = Number(this.yearsInBusiness)
      return `year${num === 1 ? '' : 's'}`
    },
  },
}
</script>

<style scoped>
  .label_size {
    font-size: 1.1rem !important; 
  }
</style>



// WEBPACK FOOTER //
// src/components/buyer-listing-details/full-details-content/SellerInformation.vue